import React from 'react';
import PropTypes from 'prop-types';

import { messages } from '../messages';
import { useSalesOrderForFulfillmentId } from '../../../hooks/entities/selectors/fulfillments';

const SourceColumn = ({ fulfillmentId }) => {
  const salesOrder = useSalesOrderForFulfillmentId(fulfillmentId);
  const { originalSource } = salesOrder;

  return originalSource ?? '';
};

SourceColumn.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const Source = {
  getMessageDescriptor: () => messages.source,
  id: 'source',

  render: (data) => {
    return <SourceColumn fulfillmentId={data.id} />;
  },
};
